import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DevOpsOutageFormComponent } from './devopsoutageform/dev-ops-outage-form.component';
import { DevopsreleasenotesComponent } from './devopsreleasenotes/devopsreleasenotes.component';
import { LoginpageComponent } from './loginpage/loginpage.component';
import { AuthGuard } from './services/auth.guard';

const routes: Routes = [
  {
    component: LoginpageComponent,
    path: '',
  },
  {
    component: DevOpsOutageFormComponent,
    path: 'devopsoutageform',
    canActivate:[AuthGuard]
  },
  {
    component: DevopsreleasenotesComponent,
    path: 'devopsreleasenotes',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
